import { render, staticRenderFns } from "./OrderPropertyValueList.vue?vue&type=template&id=0f3f4786&"
import script from "./OrderPropertyValueList.vue?vue&type=script&lang=js&"
export * from "./OrderPropertyValueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\Projekte\\plentyupdates\\RKCeres\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f3f4786')) {
      api.createRecord('0f3f4786', component.options)
    } else {
      api.reload('0f3f4786', component.options)
    }
    module.hot.accept("./OrderPropertyValueList.vue?vue&type=template&id=0f3f4786&", function () {
      api.rerender('0f3f4786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/OrderPropertyValueList.vue"
export default component.exports